import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { breakpoints, spacing, fontStyle } from '@naf/theme';
import { GridCol } from '@naf/grid';
import { Text } from '@naf/text';

export const Container = styled.main``;

export const StyledGridCol = styled(GridCol)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: ${spacing.space56};

  @media (max-width: ${breakpoints.m}) {
    align-items: center;
    padding-bottom: 0;
  }
`;

export const StyledImageGridCol = styled(GridCol)`
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    width: 75%;
    height: auto;
  }
`;

export const Wrapper = styled.div`
  margin-top: ${spacing.space48};

  @media (min-width: ${breakpoints.l}) {
    img {
      margin-left: ${spacing.space80};
    }
  }

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space40};
  }
`;

export const StyledButton = simbaStyled(Button)(() => ({
  '&&': {
    [`@media (max-width: ${breakpoints.m})`]: {
      display: 'none',
    },
  },
}));

export const StyledButtonMobile = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    display: 'none',
    [`@media (max-width: ${breakpoints.m})`]: {
      display: 'flex',
      marginBottom: theme.spacing(4),
    },
  },
}));

export const Header = styled(Text)`
  margin: 0;
  font-size: 4rem;
  line-height: 4.5rem;

  @media (max-width: ${breakpoints.m}) {
    font-size: 2rem;
    line-height: 2.5rem;
    margin-top: ${spacing.space24};
  }
`;

export const StyledText = styled(Text)`
  margin-top: ${spacing.space40};
  margin-bottom: ${spacing.space40};

  @media (max-width: ${breakpoints.m}) {
    font-size: ${fontStyle?.article?.articleText['font-size'] || '1.125rem'};
    line-height: ${fontStyle?.article?.articleText['line-height'] || '1.75rem'};
    margin-top: ${spacing.space24};
    margin-bottom: ${spacing.space24};
    text-align: center;
  }
`;
